// import account from './account'
import user from "./user";
import setting from "./setting";

export default { user, setting };
